import { LocationModel, LocationProvidersModel, LocationTrackingModel, PaymentGatewayConfiguration, ProviderModel } from "../../entities";
import ServiceModel from "../../entities/booking/ServiceModel";
import { BaseDataRepository } from "../BaseDataRepository";

export class LocationRepo extends BaseDataRepository<LocationModel> {
  protected baseUrl = 'location';

  async getServices(id: number): Promise<ServiceModel[] | null> {
    if (!id) return null;
    const response = await this.client.get(`${this.baseUrl}/${id}/services`);
    return this.handleResponse<Promise<ServiceModel[]>>(response);
  }

  async getLocationsByRoleAccess(userId: number): Promise<LocationProvidersModel[] | null> {
    const response = await this.client.get(`${this.baseUrl}/user?userId=${userId}`)
    return this.handleResponse<Promise<LocationProvidersModel[]>>(response)
  }

  async getProviderServices(id: number): Promise<ServiceModel[] | null> {
    if (!id) return null;
    const response = await this.client.get(`${this.baseUrl}/${id}/providerservices`);
    return this.handleResponse<Promise<ServiceModel[]>>(response);
  }


  async getProviderLocationsByUserIdAsync(id: number): Promise<LocationModel[]> {
      const response = await this.client.get(`${this.baseUrl}/user/${id}`);
      return this.handleResponse<LocationModel[]>(response)!;
    }

    async getWithAddressAndRegion(locationCode: string): Promise<LocationModel | null> {
      const response = await this.client.get(`${this.baseUrl}/getwithaddressandregion/${locationCode}`);
      return this.handleResponse<LocationModel>(response);
    }

    async getByLocationCodeAsync(locationCode: string): Promise<LocationModel | null> {
      const response = await this.client.get(`${this.baseUrl}/${locationCode}/locationcode`);
      return this.handleResponse<LocationModel>(response);
    }

    async getTrackingAsync(locationCode: string): Promise<LocationTrackingModel | null> {
      const response = await this.client.get(`${this.baseUrl}/${locationCode}/tracking`);
      return this.handleResponse<LocationTrackingModel>(response, false, false);
    }

    async getProvidersByLocationCode(locationCode: string): Promise<ProviderModel[] | null> {
      const response = await this.client.get(`${this.baseUrl}/GetProvidersByLocationCode/${locationCode}`);
      return this.handleResponse<ProviderModel[]>(response);
    }

    async getPaymentOptionsAsync(id: number): Promise<PaymentGatewayConfiguration | null>{
      const response = await this.client.get(`${this.baseUrl}/${id}/paymentoption`);
      return this.handleResponse<PaymentGatewayConfiguration>(response);
    }   

    async getPublicPaymentOptionsAsync(id: number): Promise<PaymentGatewayConfiguration | null>{
      const response = await this.client.get(`${this.baseUrl}/${id}/publicpaymentoption`);
      return this.handleResponse<any>(response);
    }

    async addPaymentOptionsAsync(id: number, paymentOptions: PaymentGatewayConfiguration): Promise<PaymentGatewayConfiguration | null>{
      const response = await this.client.post(`${this.baseUrl}/${id}/paymentoption`, paymentOptions);
      return this.handleResponse<PaymentGatewayConfiguration>(response);
    }    
}

export default LocationRepo;
